<template>
  <button v-bind:class="{ outline: outline }" @click="onClick">
    {{text}}
  </button>
</template>

<script>
export default {
  name: 'septima-button',
  props: {
    outline: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Click me',
    },
    onClick: {
      type: Function,
      default: (e) => {
        console.log(e);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
button {
  background-color: $default-color-dark;
  font-family: 'Open Sans', 'sans-serif';
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  line-height: 20px;
  height: 46px;
  min-width: 150px;
  border-radius: 2px;
  position: relative;
  cursor: pointer;
  border: none;
  text-decoration: none;
  padding: 0 20px;
  margin: 10px;
  transition: background .3s ease, border .3s ease;
}

button:hover {
  background: $default-color-light;
}
button.outline {
  background: transparent;
  border: solid 1px $thin-line-color;
  color: $text-color;
}
button.outline:hover {
  border: solid 1px $default-color;
  color: $default-color;
}
</style>
